export default theme => ({
  cursor: { cursor: 'pointer' },
  icon: { width: '0.875rem', height: '0.875rem', marginLeft: 6, marginBottom: -2, color: theme.palette.text.icon },
  popoverPaper: { transform: `translate(${theme.spacing(1)}, -${theme.spacing(8)}) !important`, backgroundColor: 'transparent' }
});
